import React from "react";
import InformTable from "../Components/InformTable";
import InformDescription from "../Components/InformDescription";
import { HistoryAction } from "../HistoryActionModel";
import { buildValuesTableData, buildDateTableData } from "../utils/historyActionHelpers";

const formatProductValue = (property: string, value: any): string | null => {
    if (value === null || value === undefined) return null;
    if (["IsFree", "IsTrial", "HasLifeTime"].includes(property)) return value ? "Yes" : "No";
    return String(value);
};

const ProductDeleted: React.FC<{ action: HistoryAction }> = ({ action }) => {
    const descriptionChange = action.Changes.find(c => c.Property === "Description");
    const description = descriptionChange?.OldValue ? String(descriptionChange.OldValue) : null;

    const general = buildValuesTableData(action.Changes, "old", formatProductValue, ["Description"]);
    const dates = buildDateTableData(action.Changes, "old");

    return (
        <div className="inform_panel">
            <InformTable data={general} label="General" />
            {dates.length > 0 && <InformTable data={dates} label="Date" />}
            {description && <InformDescription description={description} label="Description" />}
        </div>
    );
};

export default ProductDeleted;
